import React, {useEffect, useMemo, useState} from 'react';
import getDiscountAmountByProduct from '../../resolvers/getDiscountAmountByProduct';
import getDiscountDaysByProduct from '../../resolvers/getDiscountDaysByProduct';
import moment from 'moment';
import { formatNumberWithSeparator } from '../../lib/formatNumberWithSeparator';
import SafeHtml from '../General/SafeHtml';

export default function TableDiscount({
    currency,
    product,
    services,
    productCurrentProductId,
    setSubtitle,
}) {
    const DISCOUNT_TEXT_DEFAULT = 'Discount for unused balance by the current license.';
    const [discountCost, setDiscountCost] = useState('-');
    const discountDays = getDiscountDaysByProduct(product)
        ? getDiscountDaysByProduct(product) + ' days'
        : '';
    const sign = <SafeHtml as={'span'} html={currency?.sign} />;

    const validTill =
        productCurrentProductId === 7
            ? product?.account_valid_till ?? product?.valid_till
            : product?.valid_till;

    const licenseValidTill = useMemo(
        () => (validTill ? moment(validTill).format('MMM DD YYYY') : ''),
        [validTill]
    );

    const [discountText, setDiscountText] = useState(DISCOUNT_TEXT_DEFAULT);
    const currencyRate = product?.tariff?.cost_local?.hasOwnProperty(currency?.currency) ? 1 : (currency?.rate || 1);

    const setSubtitleText = (text) => {
        if (typeof setSubtitle === 'function') {
            setSubtitle(text);
        }
    };

    useEffect(() => {
        let subtitle = '';
        const text = productCurrentProductId === 6 ? 'URLs' : 'sites';

        if (licenseValidTill && productCurrentProductId === 7) {
            subtitle = `Current license is valid till ${licenseValidTill}.`;
            setDiscountText(`<i class="color--grey-4"> ${subtitle}</i>`);
            setSubtitleText(subtitle);
            return;
        }

        if (licenseValidTill && services && services > 0) {

            const servicesText = services === 0 ? 'unlimited' : services;
            const extraText = product.includeExtra ? '' : ' with Extra package';
            const subtitle = `Current license is valid till ${licenseValidTill} and including up to ${servicesText} ${text}${extraText}.`;

            setDiscountText(
                `<p class="bold mb-7">Discount for unused balance on the current package</p>` +
                    `<i class="color--grey-4">${subtitle}</i>`
            );

        } else if (licenseValidTill) {
            subtitle = `Current license is valid till ${licenseValidTill} and including up to ${
                services === 0 ? 'unlimited' : services
            } ${text}.`;
            setDiscountText(`<i class="color--grey-4"> ${subtitle}</i>`);
        } else {
            setDiscountText(DISCOUNT_TEXT_DEFAULT);
        }
        setSubtitleText(subtitle);
    }, [product, licenseValidTill, productCurrentProductId, services, setSubtitleText]);

    useEffect(() => {
        setDiscountCost(
            <>
                {sign}
                {Number(getDiscountAmountByProduct(product, currency) * currencyRate).toFixed(2)}
            </>
        );
    }, [product, currency, currencyRate]);

    // DB API has a different discounts UI.
    if (product?.product_id === 2 && product?.bonus_amount > 0) {
        return (
            <div className={'section__row section__row--extra'}>
                <div className={'section__cell section__cell--name'}>
                    <p className={'text bold'}>
                        <span className={'color--blue-2'}>
                             {formatNumberWithSeparator(product?.bonus_amount)} {product?.units ?? 'checks'}
                        </span>{' '}
                        (Units) available as bonus from previous license.
                    </p>
                </div>
                <div
                    className={
                        'section__cell section__cell--sites tablet-pt-7 tablet-pb-7 hide-tablet'
                    }
                ></div>
                <div
                    className={
                        'section__cell section__cell--per-site tablet-pt-7 tablet-pb-7 hide-tablet'
                    }
                ></div>
                <div className={'section__cell section__cell--sum tablet-pt-7'}></div>
            </div>
        );
    }

    return (
        <div className={'section__row section__row--extra'}>
            <div className={'section__cell section__cell--name'}>
                <div className={'text'}>
                    <SafeHtml as={'span'} html={discountText} />
                    <i className={'color--grey-4'}>&nbsp;({discountDays})</i>
                </div>
            </div>
            <div className={'section__cell section__cell--sites hide-tablet'}></div>
            <div className={'section__cell section__cell--per-site hide-tablet'}></div>
            <div className={'section__cell section__cell--sum tablet-pt-7 tablet-mb-13 color--green'}>
                <span>(save {discountCost})</span>
            </div>
        </div>
    );
}
